// extracted by mini-css-extract-plugin
export default {"icon":"SelectCore_icon__-lyVx","select":"SelectCore_select__kzGkc"};